<template>
  <header
    id="conversation-header"
    ref="conversationHeader"
    :style="`background-image: linear-gradient(to top, ${lightenColor(
      rgbToHex(settings.bgColorRGB),
      20
    )}, rgba(${settings.bgColorRGBA})); color: rgba(${
      settings.fontColorRGBA
    });`"
    class="octadesk-app-header conversation-header"
    :class="{ 'stories-header': hasMediaHeader }"
  >
    <img v-if="hasMediaHeader" :src="selectedStorie.headerUrl" />

    <div
      v-if="currentAgent && !hasMediaHeader"
      class="octadesk-app-avatar avatar--big"
    >
      <img
        v-if="currentAgent.thumbUrl"
        :src="currentAgent.thumbUrl.replace('http:', 'https:')"
      />

      <div
        v-else
        class="
          octadesk-app-disc
          d-flex
          align-items-center
          justify-content-center
        "
        :style="`color: rgba(${settings.bgColorRGBA}); background-color: rgba(${settings.fontColorRGBA}`"
      >
        <p v-text="avatarName() || currentAgent.name[0]"></p>
      </div>

      <div class="connection-status--badge--container">
        <div
          class="connection-status--badge--circle"
          :class="connectionStatus"
        ></div>
      </div>
    </div>

    <div v-if="currentAgent && !hasMediaHeader">
      <p
        class="octadesk-app-header-name header--name"
        v-text="displayName() || currentAgent.name"
      ></p>

      <p v-if="currentAgent.type !== 4" class="agent--conection-status--text">
        {{ connectionStatusText }}
      </p>
    </div>

    <ConversationHeaderActions />
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import ConversationHeaderActions from './ConversationHeaderActions'

  export default {
    components: {
      ConversationHeaderActions
    },
    computed: {
      ...mapGetters([
        'settings',
        'agent',
        'conversationMessages',
        'inBotFlux',
        'selectedStorie'
      ]),
      connectionStatus() {
        return 'online'
      },
      connectionStatusText() {
        return this.$t('conversation.header.available')
      },
      currentAgent() {
        if (this.agent) {
          return this.agent
        } else {
          return (
            this.inBotFlux && this.firstBotMessage && this.firstBotMessage.user
          )
        }
      },
      firstBotMessage() {
        return this.conversationMessages.find(
          m => m.extendedData && m.extendedData.bot
        )
      },
      hasMediaHeader() {
        return (
          this.selectedStorie &&
          typeof this.selectedStorie.headerUrl !== 'undefined' &&
          this.selectedStorie.headerUrl !== ''
        )
      }
    },
    updated() {
      this.getHeaderHeight()
    },
    mounted() {
      this.getHeaderHeight()

      this.subscribeWindowResize()
    },
    beforeDestroy() {
      this.unsubscribeWindowResize()
    },
    methods: {
      ...mapActions(['updateHeaderHeight']),
      rgbToHex(rgb) {
        const hex = rgb.split(',').map(color => {
          let hexColor = Number(color).toString(16)
          if (hexColor.length < 2) {
            hexColor = '0' + hexColor
          }
          return hexColor
        })

        return hex.join('')
      },
      lightenColor(color, percentage) {
        const num = parseInt(color.replace('#', ''), 16)

        const amt = Math.round(2.55 * percentage)

        const R = (num >> 16) + amt

        const B = ((num >> 8) & 0x00ff) + amt

        const G = (num & 0x0000ff) + amt

        return (
          '#' +
          (
            0x1000000 +
            (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
            (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
            (G < 255 ? (G < 1 ? 0 : G) : 255)
          )
            .toString(16)
            .slice(1)
        )
      },
      getHeaderHeight() {
        this.$nextTick(() => {
          if (this.$refs.conversationHeader) {
            const styles = window.getComputedStyle(
              this.$refs.conversationHeader
            )

            const margin =
              parseFloat(styles['marginTop'].replace('px', '')) +
              parseFloat(styles['marginBottom'].replace('px', ''))

            const headerHeight = Math.ceil(
              this.$refs.conversationHeader.offsetHeight + margin
            )

            this.updateHeaderHeight(headerHeight)
          }
        })
      },
      subscribeWindowResize() {
        this.$nextTick(function () {
          window.addEventListener('resize', this.getHeaderHeight)
        })
      },
      unsubscribeWindowResize() {
        window.removeEventListener('resize', this.getHeaderHeight)
      },
      displayName() {
        if (this.currentAgent.displayName !== undefined) {
          return this.currentAgent.displayName
        }
      },
      avatarName() {
        if (this.displayName() !== undefined) {
          return this.displayName()[0]
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .online {
    background-color: #50b848;
  }

  .offline {
    background-color: #c2c2c2;
  }

  .ocupado {
    background: #ecb241;
  }

  .header--name {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .conversation-header {
    display: flex;
    align-items: center;
    position: relative;
  }

  #conversation-header.octadesk-app-header {
    padding: 20px 37px 20px 1rem !important;
  }

  .avatar--big {
    width: 35px;
    height: 35px;
    font-size: 25px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    @media (max-height: 600px) {
      width: 35px;
      height: 35px;
      margin-right: 16px;
    }
  }

  .agent--conection-status--text {
    opacity: 0.83;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin: 0;
  }

  .octadesk-app-avatar.avatar--big {
    & > div:last-child {
      right: -2px !important;
      bottom: -2px !important;
      width: 14px !important;
      height: 14px !important;
      padding: 2px !important;
      div {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }

  .connection-status--badge--container {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 18px;
    height: 18px;
    padding: 4px;
    border-radius: 100%;
    background: #fff;
  }

  .connection-status--badge--circle {
    width: 10px;
    height: 10px;
    border-radius: 100%;
  }

  #conversation-header.octadesk-app-header.stories-header {
    padding: 0px !important;
    img {
      width: 100%;
      height: auto;
      border-radius: 8px 8px 0px 0px;
      pointer-events: none;
    }
  }
</style>
